import { QueryClient } from "@tanstack/react-query";

import { transitionDetailsKeyMaker } from "@fartherfinance/frontend/api/TransitionWorkflows/hooks/useGetTransitionDetails";
import { transitionsKeyMaker } from "@fartherfinance/frontend/api/TransitionWorkflows/hooks/useGetTransitions";

/**
 * Query invalidation utilities for transition-related data
 */
export const queryInvalidationUtils = {
  /**
   * Invalidates task queries that use filterByTaskIds parameter
   * Used for: task tables, next tasks, transition progress
   */
  invalidateTaskQueries: (queryClient: QueryClient): void => {
    queryClient.invalidateQueries({
      predicate: (query) => {
        if (
          !query.queryKey ||
          !Array.isArray(query.queryKey) ||
          query.queryKey.length < 2
        ) {
          return false;
        }

        const url = query.queryKey[0];
        const params = query.queryKey[1];

        if (typeof url === "string" && url.includes("/tasks")) {
          if (typeof params === "string") {
            try {
              const parsedParams = JSON.parse(params);
              return parsedParams.hasOwnProperty("filterByTaskIds");
            } catch {
              return false;
            }
          }
        }

        return false;
      },
    });
  },

  /**
   * Invalidates advisor transition queries
   * Used for: transition details, transition overview
   */
  invalidateTransitionQueries: (
    queryClient: QueryClient,
    transitionId?: string
  ): void => {
    if (transitionId) {
      queryClient.invalidateQueries({
        queryKey: transitionDetailsKeyMaker(transitionId),
      });
    } else {
      // Fallback to invalidate all transitions using transitionsKeyMaker
      queryClient.invalidateQueries(transitionsKeyMaker(undefined));
    }
  },
};
